export default __webpack_public_path__ + "static/media/grafema_coimbra-2027-contest_18.d1556b1d.jpg";